export default {
    emits: ['update:value'],
    props: {
        theme: {
            validator: val =>
                ['standard', 'template1', 'template4', 'broker'].includes(val),
            default: 'standard'
        },
        label: {
            //  title 
            type: String,
            default: ''
        },
        value: {
            // v-model
            type: String,
            default: ''
        },
        minTitle: {
            //  Left  placeholder
            type: String,
            default: ''
        },
        maxTitle: {
            //  right  placeholder
            type: String,
            default: ''
        },
        inMore: {
            type: Boolean,
            default: false
        }
    },
    methods: {
        formatMaxValue(val, type = 'max') {
            if (!val) {
                return val; 
            }
            let date = new Date(+val);
            const year = date.getFullYear();
            let month = date.getMonth() + 1;
            month = month > 9 ? `${month}` : `0${month}`;
            const day = date.getDate();
            const time = type === 'max' ? '23:59:59' : '00:00:00';
            return new Date(`${year}/${month}/${day} ${time}`).getTime() + '';
        }
    }
};
